export default __webpack_public_path__ + "static/gift-card-5.url-339e9643ae0f4c7428a6bee6d4a2af12.svg";